// #6275: the "</> key · chip" line under an Edit column modal's label, shared by the transaction
// column settings and the cap table configuration. Styled by main.css's .ctcc-identity / .ctcc-chip.

const CHIP_LABELS = { standard: 'Standard', custom: 'Custom', formula: 'Formula', field: 'Field' };

function esc(value) {
	return String(value ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

/**
 * @param {{ type?: 'standard'|'custom'|'formula'|'field', key: string, chipLabel?: string, detail?: string }} info
 *   detail: muted text after the chip (e.g. the source path of a computed field)
 */
export function columnIdentityHtml({ type = 'standard', key, chipLabel, detail }) {
	const kind = CHIP_LABELS[type] ? type : 'field';
	return (
		`<i class="material-icons" aria-hidden="true">code</i>` +
		`<code>${esc(key)}</code>` +
		`<span class="ctcc-chip ctcc-chip--${kind}">${esc(chipLabel || CHIP_LABELS[kind])}</span>` +
		(detail ? `<span class="ctcc-identity-detail">${esc(detail)}</span>` : '')
	);
}

export function renderColumnIdentity(el, info) {
	el.innerHTML = columnIdentityHtml(info);
}

// Cap table columns carry a `source`: '' / 'custom' (typed by hand), 'formula:<expr>', or a computed field
export function describeCapTableSource(col) {
	const source = col?.source || '';
	if (!source || source === 'custom' || col?.isManual) return { type: 'custom' };
	if (source.startsWith('formula:')) return { type: 'formula', detail: source.slice('formula:'.length) };
	const prefixed = source.match(/^(calculator|aggregate|expression|classifier):(.*)$/);
	if (prefixed) return { type: 'field', chipLabel: prefixed[1][0].toUpperCase() + prefixed[1].slice(1), detail: prefixed[2] };
	if (source.startsWith('calc.')) return { type: 'field', chipLabel: 'Calculator', detail: source.slice('calc.'.length) };
	if (source.startsWith('userClient.')) return { type: 'field', chipLabel: 'Client field', detail: source.slice('userClient.'.length) };
	if (source.startsWith('user.')) return { type: 'field', chipLabel: 'User field', detail: source.slice('user.'.length) };
	return { type: 'field', detail: source };
}
